import Notification from "../notification";
import {useMainStore} from "@/store";

export default class CurrenciesUpdated extends Notification
{
    handle() {
        switch(this.message.data.type) {
            case 'coins':
                useMainStore().UPDATE_COINS(this.message.data.change);
                break;
            case 'attribute_points':
                useMainStore().UPDATE_ATTRIBUTE_POINTS(this.message.data.change);
                break;
            case 'tickets':
                useMainStore().UPDATE_TICKETS(this.message.data.change);
                break;
            default:
                //
        }
    }
}
